import React, { Component } from 'react';
import BarChart from './charts/bar_chart'
import MeterChart from './charts/meter_chart'

class DashBoardContentModules extends Component {
  complianceRatingsCharts(complianceRatings) {
    return complianceRatings.map((rating, index) => {
      var radius = 50
      var width = 245
      var label = ""
      var className = "individual-module-charts"

      if(rating.label.indexOf("Overall") !== -1) {
        radius = 100
        width = 520
        label = "Overall Training Compliance (All Staff + Team Specific)"
        className = ""
      }
      else if(rating.label.indexOf("All") !== -1) {
        label = "All Staff Compliance"
      }
      else if(rating.label.indexOf("Field") !== -1) {
        label = "Field Staff Compliance"
      }
      else if(rating.label.indexOf("Other") !== -1) {
        label = "Team Specific Compliance"
      }
      else if(rating.label.indexOf("Emergency") !== -1) {
        label = "Emergency Response Compliance"
      }
      return (
        <div className={ className } key={ index }>
          <MeterChart key={ index } name={ 'compliance-ratings' + index } value={ rating.value } width={ width } radius={ radius } label={ label }/>
        </div>
      )
    })
  }

  modulesComplianceRatingCharts(moduleComplianceRatings) {
    var barChart = []
    var labels = {
      "all": "All Staff Compliance",
      "field": "Field Staff Compliance",
      "other": "Team Specific Compliance",
      "emergency": "Emergency Response - Project",
    }
    for(var key in moduleComplianceRatings) {
      if (moduleComplianceRatings[key].length === 0) continue
      barChart = barChart.concat(<BarChart key={ 'modules' + key } name={ 'modules-compliance-' + key } data={ moduleComplianceRatings[key] } width={ 520 } height={ 500 } label={ labels[key] }/>)
    }
    return barChart
  }

  render() {
    return (
      <div className="dashboard-content">
        <div className="left-content">
          { this.props.complianceRatings && this.complianceRatingsCharts(this.props.complianceRatings) }
        </div>
        <div className="right-content">
          { this.modulesComplianceRatingCharts(this.props.moduleComplianceRatings) }
        </div>
        {
          this.props.loading &&
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>Loading dashboard...</span>
          </div>
        }
      </div>

    )
  }
}

export default DashBoardContentModules;



// WEBPACK FOOTER //
// ./src/views/components/dashboard_content_modules.js